import React from 'react';
import Navigation from '../../Components/Navigation/Navigation';
import DetailOffice from '../../Components/OfficeComp/DetailOffice';
import Footer from '../../Components/Footer/Footer';

const DetailOfficePage = () => {
  return (
    <>
      <Navigation />
      <DetailOffice />
      <Footer />
    </>
  );
};

export default DetailOfficePage;
